'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Overlay = require('react-bootstrap/lib/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _propTypes3 = require('utils/prop-types');

var _ShareLinkPopover = require('components/ShareLinkButton/ShareLinkPopover');

var _ShareLinkPopover2 = _interopRequireDefault(_ShareLinkPopover);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ShareLinkButton.scss');

var ShareLinkButton = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ShareLinkButton, _PureComponent);

  function ShareLinkButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, ShareLinkButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareLinkButton.__proto__ || (0, _getPrototypeOf2.default)(ShareLinkButton)).call.apply(_ref, [this].concat(args)));

    _this.state = { showPopover: false };
    return _this;
  }

  (0, _createClass3.default)(ShareLinkButton, [{
    key: 'onCopy',
    value: function onCopy(result) {
      var t = this.context.t;
      var _props = this.props,
          onCopy = _props.onCopy,
          _props$onCopyErrorMes = _props.onCopyErrorMessage,
          onCopyErrorMessage = _props$onCopyErrorMes === undefined ? t('Link copying error') : _props$onCopyErrorMes,
          _props$onCopySuccessM = _props.onCopySuccessMessage,
          onCopySuccessMessage = _props$onCopySuccessM === undefined ? t('Link successfully copied') : _props$onCopySuccessM;


      if (result && onCopySuccessMessage) {
        _toastr2.default.info(onCopySuccessMessage);
        this.setState({ showPopover: false });
      }
      if (!result && onCopyErrorMessage) {
        _toastr2.default.error(onCopyErrorMessage);
      }

      onCopy(result);
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      (0, _utils.stopEvent)(e);
      this.setState({ showPopover: !this.state.showPopover, target: this.buttonEl });
    }
  }, {
    key: 'hidePopover',
    value: function hidePopover() {
      this.setState({ showPopover: false });
    }
  }, {
    key: 'bindButton',
    value: function bindButton(el) {
      this.buttonEl = el;
      this.setState({ target: el });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.context.t;
      var _props2 = this.props,
          className = _props2.className,
          buttonClass = _props2.buttonClass,
          placement = _props2.placement,
          trigger = _props2.trigger,
          id = _props2.id,
          link = _props2.link,
          onClick = _props2.onClick,
          title = _props2.title;
      var _state = this.state,
          showPopover = _state.showPopover,
          target = _state.target;


      return _react2.default.createElement(
        'span',
        { className: className, title: t('Share the link'), onClick: this.togglePopover, ref: this.bindButton },
        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.button, buttonClass) }),
        _react2.default.createElement(
          _Overlay2.default,
          {
            show: showPopover,
            placement: placement,
            trigger: trigger,
            rootClose: true,
            onEnter: onClick,
            onHide: this.hidePopover,
            target: target
          },
          _react2.default.createElement(_ShareLinkPopover2.default, { id: id, link: link, title: title, onCopy: this.onCopy })
        )
      );
    }
  }]);
  return ShareLinkButton;
}(_react.PureComponent), _class2.propTypes = {
  buttonClass: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  link: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onCopy: _propTypes2.default.func,
  onCopyErrorMessage: _propTypes2.default.string,
  onCopySuccessMessage: _propTypes2.default.string,
  placement: _propTypes2.default.string,
  title: _propTypes3.node,
  trigger: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  link: '',
  onClick: _noop3.default,
  onCopy: _noop3.default,
  placement: 'left',
  trigger: 'click'
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onCopy', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onCopy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hidePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hidePopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindButton', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindButton'), _class.prototype)), _class);
exports.default = ShareLinkButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareLinkButton/ShareLinkButton.js
// module id = 2095
// module chunks = 1